export default __webpack_public_path__ + "static/media/DurationIcon.0ccaa760.svg";